<template>
  <ul>
    <li>
      <a
        :to="
          menulist.to
            ? base + menulist.to
            : menulist.id
            ? base + '/cmsContent/' + menulist.id
            : ''
        "
        target="_self"
        class="menuButton"
        href="#"
        :class="{ 'r-l': menulist.id }"
      >
        {{ menulist.name }}
      </a>
      <menubar
        v-for="(vm, vind) in menulist.submenu"
        :key="vind"
        :menulist="vm"
      />
    </li>
  </ul>
</template>
<script>
export default {
  name: "menubar",
  props: { menulist: Object, isopen: Boolean },
  data: () => {
    return {
      m: true,
    };
  },
  computed: {
    hasSubmenu() {
      return this.menulist.submenu && this.menulist.submenu.length > 0;
    },
  },
  watch: {
    m() {
      if (this.menulist.to || this.menulist.id) {
        this.$router.push(
          this.menulist.to
            ? this.menulist.to
            : "/cmsContent/" + this.menulist.id
        );
      }
    },
  },
  mounted() {},
  methods: {},
};
</script>
